const _module = require('./index');

_module.controller('LocalHousingMarketStatsCtrl', [
    '$events',
    '$listing',
    '$log',
    function($events, $listing, $log) {
        const vm = this;
        const cityStateZip = vm.report && vm.report.address
            ? $listing.getCityStateZip(vm.report.address)
            : null;
        const areaId = cityStateZip
            ? cityStateZip.city && cityStateZip.state
                ? cityStateZip.city + ', ' + cityStateZip.state
                : cityStateZip.zip
            : null;
        vm.model = {
            areaId: areaId,
        };
        vm.events = {
            onSeeHomesClick: function () {
                return onSeeHomesClick.apply(vm, [$events]);
            },
        };
    }
]);

function onSeeHomesClick($events) {
    const vm = this;
    $events.track('spw_local_housing_see_more_homes_button_click');
}

_module.directive('localHousingMarketStats', [function() {
    return {
        restrict: 'E',
        scope: {
            report: '=',
            stats: '=',
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: 'LocalHousingMarketStatsCtrl',
        templateUrl: 'js/components/modals/templates/local-housing-market-stats.tmpl.html'
    };
}]);
